export default [
  {
    path: '/solicitud-modificaciones-calificaciones',
    name: 'solicitud-modificaciones-calificaciones',
    component: () =>
      import(
        '@/views/academico/calificaciones/solicitud-modificacion-calificacion/layouts/SolicitudModificacionCalificacionLayout.vue'
      ),
  },
  {
    path: '/calificaciones-centralizador',
    name: 'calificaciones-centralizador',
    component: () =>
      import(
        '@/views/academico/calificaciones/centralizador/layouts/CalificacionCentralizadorLayout.vue'
      ),
  },
  {
    path: '/calificaciones-nivelaciones',
    name: 'calificaciones-nivelaciones',
    component: () =>
      import(
        '@/views/academico/calificaciones/nivelaciones/layouts/NivelacionesLayout.vue'
      ),
  },
];
